var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkillsDeXd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 79 79",
    style: {
      enableBackground: "new 0 0 79 79"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2E001F;}\n\t.st1{fill:#FF26BE;}\n\t.st2{fill:#FFD9F2;stroke:#FFD9F2;stroke-width:2;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lag_2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    className: "st0",
    width: 79,
    height: 79
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lag_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75,4v71H4V4H75 M79,0H0v79h79V0L79,0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.4,58.1h-4.7l-9.6-15.7l-9.8,15.7H9.9l11.9-18.7l-11.1-17h4.6l8.9,14.1l8.9-14.1h4.4L26.5,39.3L38.4,58.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.1,54.5h-0.2c-1.9,2.7-4.7,4.1-8.4,4.1c-3.5,0-6.2-1.2-8.2-3.6c-1.9-2.4-2.9-5.8-2.9-10.2 c0-4.4,1-7.8,2.9-10.3s4.7-3.7,8.2-3.7c3.6,0,6.4,1.3,8.3,4h0.3L61,32.9L60.9,31V20.1H65v38h-3.3L61.1,54.5z M53,55.2 c2.8,0,4.8-0.8,6-2.3c1.2-1.5,1.9-3.9,1.9-7.3v-0.9c0-3.8-0.6-6.5-1.9-8.1c-1.3-1.6-3.3-2.4-6-2.4c-2.4,0-4.2,0.9-5.5,2.8 c-1.3,1.8-1.9,4.5-1.9,7.8c0,3.4,0.6,6,1.9,7.7C48.7,54.3,50.6,55.2,53,55.2z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsDeXd);
export default __webpack_public_path__ + "static/media/skills-de_xd.cfb2b9b3b89a65aace9a78c7ea3f6172.svg";
export { ForwardRef as ReactComponent };